import React from 'react'
import './header.css'
import CTA from './CTA'
// used https://pinetools.com/round-corners-image to round image
import ME from '../../assets/my1.jpg'
import HeaderSocials from './HeaderSocials'

export default function Header() {
  return (
    <header id="home">
      <div className="container header__container">
      <div id="user-detail-intro">
      <h5>Hello I'm</h5>
      <h1 id="user-detail-name">Syed Mohamamd Gouse</h1>
      <h5 className="text-light">Full-stack Developer</h5>
      <CTA />
      <HeaderSocials />
      </div>
      <div className="me">
        <img src={ME} alt="" className='home-img' />
      </div>
      <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}
